module.exports = __webpack_public_path__ + "img/t-fh.4483f0dd.png";